<template>
  <!-- 车辆管理 -->
 <div class="app-container">
  <SearchCollapse @update-height="getHeight" :formItemsLength="16">
   <div class="formBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class=" formItemBox">
               <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
              <el-form-item label="车辆类型:" prop="vhcTypeId" >
                <el-select placeholder="请选择" v-model="searchFrom.vhcTypeId">
                  <el-option
                    v-for="item in vehicleT"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="车辆用途:" prop="purposeId">
                <el-select placeholder="请选择" v-model="searchFrom.purposeId">
                  <el-option
                    v-for="item in clyt"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="能源类型:" prop="energyType">
                <el-select placeholder="请选择" v-model="searchFrom.energyType">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆所属:" prop="vhcClassify">
                <el-select placeholder="请选择" v-model="searchFrom.vhcClassify">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="排放标准:" prop="standardsId">
                <el-select placeholder="请选择" v-model="searchFrom.standardsId">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
             <!-- <el-form-item label="车长:" prop="vhcLongId">
               <el-select placeholder="请选择" v-model="searchFrom.vhcLongId">
                <el-option
                    v-for="item in vehicleL"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item> -->
             <el-form-item label="行驶证号:" prop="drivingLicense">
                <el-input  placeholder="" v-model="searchFrom.drivingLicense"></el-input>
              </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                <el-input  placeholder="" v-model="searchFrom.weight"></el-input>
              </el-form-item>
              <el-form-item label="车架号:" prop="vhcVinNo">
                <el-input  placeholder="" v-model="searchFrom.vhcVinNo"></el-input>
              </el-form-item>
               <el-form-item label="发动机号:" prop="vhcEngineNo">
                <el-input  placeholder="" v-model="searchFrom.vhcEngineNo"></el-input>
              </el-form-item>
               <el-form-item label="随车清单:" prop="boardList">
                <el-input  placeholder="" v-model="searchFrom.boardList"></el-input>
              </el-form-item>
               <el-form-item label="所属单位:" prop="vhcCompanyName">
                <el-input  placeholder="" v-model="searchFrom.vhcCompanyName"></el-input>
              </el-form-item>
               <el-form-item label="车辆流向:"  prop="vhcFlow">
                <el-select placeholder="请选择" v-model="searchFrom.vhcFlow">
                  <el-option
                    v-for="item in cllx"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="车牌颜色:" prop="vhcNoColour">
                <el-select placeholder="请选择" v-model="searchFrom.vhcNoColour">
                  <el-option
                    v-for="item in clys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆注册日期:" prop="registerDates">
                    <el-date-picker
                      v-model="searchFrom.registerDates"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="创建时间:" prop="createTimes">
                    <el-date-picker
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="所属车队:" prop="tenantId" v-if="searchFrom.isZhb == '0'">
                    <el-select placeholder="请选择" v-model="searchFrom.tenantId" filterable @change="fleetChange">
                      <el-option
                        v-for="item in fleetData"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
       </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00BP001B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP001B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP001B002"  v-if="btnFlg[2]">
            <el-button type="primary"  @click="addVeicle">新增</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="modifyVeicle">修改</el-button>
          </el-form-item> -->
          <el-form-item btnCode="00BP001B003"  v-if="btnFlg[3]">
            <el-button type="danger" @click="delVeicle">删除</el-button>
          </el-form-item>
         <el-form-item btnCode="00BP001B006"  v-if="btnFlg[6]"><!---->
           <el-button type="primary" @click="THimportFn()">车辆导入</el-button>
         </el-form-item>
         <el-form-item btnCode="00BP001B006"  v-if="btnFlg[6]">
           <el-button type="primary" @click="modelDown">模板下载</el-button>
         </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="takeGoods">导入</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    </SearchCollapse>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'  class="tableComent"
       @row-click="handleRowClick" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" btnCode="00BP001B004"  v-if="btnFlg[4]" @click="modifyVeicle(scope.row)">修改</el-button>
                <el-button type="text" size="mini" btnCode="00BP001B005"  v-if="btnFlg[5]" v-show="scope.row.vhcPhoto1 != ''||scope.row.vhcPhoto2 != ''" @click="lookImg(scope.row)">查看照片</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
        <el-table-column property="vhcNoColour" label="车牌颜色" >
          <template scope="scope">
            <span v-if="scope.row.vhcNoColour==-1">其他</span>
            <span v-else-if="scope.row.vhcNoColour!==null"> {{[ "蓝色", "黄色", "白色", "黑色", "绿色", "渐变绿", "黄绿色", "农黄色" , "农绿色"][scope.row.vhcNoColour-1]}}</span>
          </template>
          </el-table-column>
        <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
        <el-table-column prop="tenantName" width="200" label="所属车队" v-if="searchFrom.isZhb == '0'"></el-table-column>
        <el-table-column prop="vhcT2linkName" width="150" :show-overflow-tooltip="true" label="机型/吨位"></el-table-column>
        <el-table-column prop="purposeName"  width="150" :show-overflow-tooltip="true" label="车辆用途"></el-table-column>
        <el-table-column property="vhcClassify" label="车辆所属" >
          <template scope="scope">
            {{[ "市场车辆", "自家车辆" ][scope.row.vhcClassify-1]}}
          </template>
          </el-table-column>
          <el-table-column property="vhcCompanyName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
         <el-table-column property="energyType" label="能源类型" width="80" >
          <template scope="scope">
            <span v-if="scope.row.energyType!==null">{{["其他","******", "汽油","柴油", "天然气", "电"  ][scope.row.energyType+1]}}</span>
          </template>
          </el-table-column>
        <el-table-column prop="weight" width="100"  :show-overflow-tooltip="true"  label="载重(吨)"></el-table-column>
         <el-table-column prop="standardsName" width="80" :show-overflow-tooltip="true" label="排放标准"></el-table-column>
         <el-table-column prop="boardList"  width="200" :show-overflow-tooltip="true" label="随车清单"></el-table-column>
        <!-- <el-table-column prop="vhcLongName" label="车长"></el-table-column> -->
        <el-table-column prop="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>
        <el-table-column prop="vhcVinNo"   width="170"  :show-overflow-tooltip="true" label="车架号"></el-table-column>
        <el-table-column prop="vhcEngineNo" width="100"  :show-overflow-tooltip="true" label="发动机号"></el-table-column>
         <el-table-column property="vhcFlow" label="车辆流向" >
          <template scope="scope">
            {{[ "集港", "外发"][scope.row.vhcFlow-1]}}
          </template>
          </el-table-column>
        <el-table-column prop="registerDate" width="160" :formatter="dateFormat1" label="注册日期"></el-table-column>
        <el-table-column prop="createUserName" width="160"   label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="900px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
               <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" @blur="CPHfn()" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" v-model.trim="addFrom.vhcNo" maxlength="8"></el-input>
              </el-form-item>
              <el-form-item label="车牌颜色:" prop="vhcNoColour">
                <el-select placeholder="请选择" v-model="addFrom.vhcNoColour">
                  <el-option
                    v-for="item in clys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆类型:" class="is-required"  prop="vhcType">
                <el-select placeholder="请选择" value-key="id" filterable v-model="addFrom.vhcType" @change="vhcTypeChange(addFrom.vhcType)">
                  <el-option
                    v-for="item in vehicleT"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="机型/吨位:"  prop="vhcT2linkId">
                <el-select placeholder="请选择" value-key="id"  @change="carAreaChange()" v-model="addFrom.vhcT2linkId">
                  <el-option
                    v-for="item in carTypeOptions"
                    :key="item.id"
                    :label="item.type2name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="车辆所属:" class="is-required"   prop="vhcClassify1">
                <el-cascader
                v-model="addFrom.vhcClassify1"
                :options="vehicleSSAdd"
                @change="vehicleSSAddChange"></el-cascader>
             </el-form-item>
             <!-- <el-form-item  v-if="addFrom.vhcClassify1[1]==1"    label="所属单位:" prop="vhcCompanyName">
                <el-input  placeholder=""  maxlength="40"  v-model="addFrom.vhcCompanyName"></el-input>
              </el-form-item> -->
               <el-form-item label="所属单位:" v-if="addFrom.vhcClassify1[1]==1" class="is-required"  prop="vhcCompany">
                <el-select placeholder="请选择" value-key="tenantCode"  filterable allow-create
                default-first-option v-model="addFrom.vhcCompany">
                  <el-option
                    v-for="item in ssdw"
                    :key="item.tenantCode"
                    :label="item.tenantName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="所属个人:" prop="vhcCompany1" v-if="addFrom.vhcClassify1[1]==2">
                <el-input  placeholder="" v-model="addFrom.vhcCompany1"  maxlength="11"></el-input>
              </el-form-item>
             <el-form-item label="能源类型:"  prop="energyType">
                <el-select placeholder="请选择" v-model="addFrom.energyType">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="车辆用途:"  prop="purpose">
                <el-select placeholder="请选择" value-key="id"  filterable allow-create
                default-first-option v-model="addFrom.purpose">
                  <el-option
                    v-for="item in clyt"
                   :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="排放标准:"  prop="standards">
                <el-select placeholder="请选择" value-key="id"  v-model="addFrom.standards">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <!-- <el-form-item label="车长(米):" prop="">
              <el-select placeholder="请选择" value-key="id" v-model="vhcL">
                <el-option
                    v-for="item in vehicleL"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>

                </el-select>
              </el-form-item> -->
              <el-form-item label="行驶证号:" prop="drivingLicense">
                <el-input  placeholder=""  v-number-input.float="0" maxlength="18" v-model="addFrom.drivingLicense"></el-input>
              </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                <el-input  placeholder="" v-model="addFrom.weight"  v-number-input.float="2" maxlength="11"></el-input>
              </el-form-item>

              <el-form-item label="车架号:" prop="vhcVinNo">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcVinNo"></el-input>
              </el-form-item>
               <el-form-item label="发动机号:"  prop="vhcEngineNo">
                <el-input  placeholder=""  maxlength="17"  v-model="addFrom.vhcEngineNo"></el-input>
              </el-form-item>
              <el-form-item label="注册日期:" prop="registerDate">
                <el-date-picker
                  v-model="addFrom.registerDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
               <el-form-item label="车辆流向:"  prop="vhcFlow">
                <el-select placeholder="请选择" v-model="addFrom.vhcFlow">
                  <el-option
                    v-for="item in cllx"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="所属车队:" prop="tenantId" v-if="searchFrom.isZhb == '0'">
                <el-select placeholder="请选择" v-model="addFrom.tenantId" filterable @change="fleetChange">
                  <el-option
                    v-for="item in fleetData"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
             <el-form-item label="随车清单:" prop="boardList" class="bigInp">
                <el-input  placeholder=""  maxlength="50" v-model="addFrom.boardList"></el-input>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>车辆照片</span>
              </h4>
            </div>
            <div class="box">
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove" :class="[isAddImg?'hidden':'']">
                </el-upload>
                <h6>正面照片</h6>
              </div>
               <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg1"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <h6>反面照片</h6>
              </div>

            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="lookImgVisible"  width="1000px" center>
      <div class="loogImgBox">
        <div  class="box1" v-for="item in imgUrl" :key="item">
             <img  :src="item"  alt=""/>
        </div>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn, getAttributeA } from '@/utils/getButton'
import { compressImage } from '@/utils/compressImage'
import { checkUserBelongToZhb } from '@/api/zhb-sgHarbour'
import { cVIlist, cVIadd, cVIupdate, cVIdelete, cVLlist, cVTlist, cVPlist,
  cVElist, getCVehicleInfo, getRelationCustomerFleet, impVehicleInfoExcel, listByTypeId, selectCustomerList } from '@/api/vgs-driver'
import importC from '@/components/import.vue'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  components: {
    importC, SearchCollapse
  },
  data () {
    return {
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        isZhb: null
      },
      addFrom: {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        weight: 40,
        vhcType: { id: 23 },
        vhcT2linkId: ''
      },
      importDialog: false,
      isAdd: false,
      title: '添加',
      vehicleL: [],
      vehicleT: [],
      clyt: [],
      pfbz: [],
      vhcType: {},
      vhcL: {},
      ids: [],
      // 小何协商删除和开通需要添加tenantId参数 租户code
      tenantIds: [],
      rules: {
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
          // this.rule.vhcNo
        ],
        vhcNoColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vhcCompany: [
          { required: true, message: '请输入所属单位', trigger: 'blur' }
        ],
        vhcCompany1: [
          { required: true, message: '请输入所属个人', trigger: 'blur' }
        ],
        // vhcVinNo: [this.rule.vhcVinNo],
        vhcType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vhcClassify1: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] },
          { validator: this.rule.isVhcClassify, trigger: 'blur' }],
        energyType: [{ required: true, message: '请选择能源类型', trigger: ['blur', 'change'] }],
        tenantId: [
          { required: true, message: '请选择所属车队', trigger: ['blur', 'change'] }
        ]
      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '市场车辆'
        },
        {
          value: 2,
          label: '自家车辆'
        }
      ],
      vehicleSSAdd: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '市场车辆',
          children: [
            {
              value: null,
              label: '请选择'
            },
            {
              value: 1,
              label: '单位'
            }, {
              value: 2,
              label: '个人'
            }]
        },
        {
          value: 2,
          label: '自家车辆'
        }
      ],
      NYtype: [
        { value: '', label: '请选择' },
        { value: 0, label: '******' },
        { value: -1, label: '其他' },
        { value: 1, label: '汽油' },
        { value: 2, label: '柴油' },
        { value: 3, label: '天然气' },
        { value: 4, label: '电' }
      ],
      cllx: [
        { value: '', label: '请选择' },
        { value: 1, label: '集港' },
        { value: 2, label: '外发' }
      ],
      clys: [
        { value: '', label: '请选择' },
        { value: 1, label: '蓝色' },
        { value: 2, label: '黄色' },
        { value: 3, label: '白色' },
        { value: 4, label: '黑色' },
        { value: 5, label: '绿色' },
        { value: 6, label: '渐变绿' },
        { value: 7, label: '黄绿色' },
        { value: 8, label: '农黄色' },
        { value: 9, label: '农绿色' },
        { value: -1, label: '其他' }
      ],
      ssdw: [],
      isAddImg: false,
      isAddImg1: false,
      listImg: [],
      listImg1: [],
      imgUrl: [],
      imgfile: new FormData(),
      btnFlg: [],
      btnIdArr: ['00BP001B000', '00BP001B001', '00BP001B002',
        '00BP001B003', '00BP001B004', '00BP001B005', '00BP001B006'],
      typeId: '',
      carTypeOptions: [],
      fleetData: [],
      checkZHB: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/vehicle')
    // this.getList(this.searchFrom)
    this.getAttributeA()
    this.checkUserBelongToZhb()
    this.selectCustomerList()
    cVLlist({}).then(res => {
      this.vehicleL = res
      this.vehicleL.unshift({ id: '', name: '请选择' })
    })
    cVTlist({}).then(res => {
      this.vehicleT = res
      // this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
    getRelationCustomerFleet({}).then(res => {
      this.ssdw = JSON.parse(res)
    })
    this.imgfile.append('vhcPhoto1File', '')
    this.imgfile.append('vhcPhoto2File', '')
    this.imgfile.append('params', '')
  },
  mounted () {
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 168) + 'px'
      })
    },
    checkUserBelongToZhb () {
      checkUserBelongToZhb().then(res => {
        console.log(res, '123')
        // 0 是 1否
        this.checkZHB = true
      })
    },
    getAttributeA () {
      getAttributeA('ARRisShowFleet', localStorage.getItem('tenantCode')).then(res => {
        console.log(res, '123')
        // 0 是 1否
        this.searchFrom.isZhb = res[0]
        this.getList(this.searchFrom)
      })
    },
    // 中厚板获取所属车队
    selectCustomerList () {
      selectCustomerList({}).then(res => {
        console.log(res, '车队')
        this.fleetData = res
      })
    },
    fleetChange (e) {
      this.fleetData.forEach(item => {
        if (e == item.code) {
          this.$set(this.addFrom, 'tenantName', item.name)
        }
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cVIlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        // 解决表格固定列错位
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.table.doLayout()
          })
        }, 300)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    vehicleSSAddChange (value) {
      this.$set(this.addFrom, 'vhcCompany', '')
      this.$set(this.addFrom, 'vhcCompany1', '')
      this.$set(this.addFrom, 'vhcCompanyName', '')
      this.$set(this.addFrom, 'vhcCompanyCode', '')
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/%E8%BD%A6%E8%BE%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      impVehicleInfoExcel(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.$message({
          showClose: false,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {
            loading.close()
          }
        })
        that.getList(that.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: false,
          message: error.message,
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    closeDialogFile () {
      this.$refs.file.value = ''
    },
    // 图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      this.addFrom.vhcPhoto1 = ''
      this.listImg = fileList
    },

    imgPreview (file, fileList) {
      console.log(file, fileList)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg = fileList
    },
    // 图片上传
    handleRemove1 (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg1 = false
      }
      this.addFrom.vhcPhoto2 = ''
      this.listImg1 = fileList
    },

    imgPreview1 (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg1 = false
        } else {
          this.isAddImg1 = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg1 = fileList
    },
    // 查看图片
    lookImg (row) {
      this.imgUrl = []
      if (row.vhcPhoto1 != '') {
        this.imgUrl.push(row.vhcPhoto1Url)
      }
      if (row.vhcPhoto2 != '') {
        this.imgUrl.push(row.vhcPhoto2Url)
      }
      if (this.imgUrl.length == 0) {
        this.$alert('该车辆没有上传图片', '系统提示')
      } else {
        this.lookImgVisible = true
      }
    },
    // 获取车辆信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        getCVehicleInfo({ vhcNo: this.addFrom.vhcNo }).then(res => {
          loading.close()
          if (res.id) {
            this.fuzhi(res)
          } else {
            let vhcNo = this.addFrom.vhcNo
            this.addFrom = {
              vhcNo: vhcNo,
              vhcClassify1: this.addFrom.vhcClassify1,
              vhcPhoto1: '',
              vhcPhoto2: '',
              weight: 40,
              vhcType: { id: 23 }
            }
            this.vhcType = {}
            this.vhcL = {}
            this.listImg = []
            this.listImg1 = []
            this.isAddImg = false
            this.isAddImg1 = false
          }
        }).catch(error => {
          this.$message({
            showClose: false,
            message: error.message,
            duration: 3000,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 添加
    addVeicle () {
      this.addFrom.vhcClassify1 = []
      this.title = '添加'
      if (this.checkZHB) {
        this.addFrom.vhcClassify1.push(this.vehicleSSAdd[2].value)
        console.log(this.addFrom.vhcClassify1)
      }
      this.dialogVisible = true
      this.isAdd = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 车辆赋值
    fuzhi (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (row.vhcClassify == 1) {
        this.$set(this.addFrom, 'vhcClassify1', [row.vhcClassify, row.vhcNature])
      } else {
        this.$set(this.addFrom, 'vhcClassify1', [row.vhcClassify])
      }
      if (row.vhcTypeId) {
        this.$set(this.addFrom, 'vhcType', { id: row.vhcTypeId, name: row.vhcTypeName })
      }
      if (row.vhcT2linkId) {
        this.$set(this.addFrom, 'vhcT2linkId', row.vhcT2linkId)
      }
      if (row.vhcNature == 1) {
        if (row.vhcCompanyName) {
          if (row.vhcCompanyCode == -1 || row.vhcCompanyCode == '') {
            this.$set(this.addFrom, 'vhcCompany', row.vhcCompanyName)
          } else {
            this.$set(this.addFrom, 'vhcCompany', { tenantCode: row.vhcCompanyCode, tenantName: row.vhcCompanyName })
          }
        }
      } else {
        this.$set(this.addFrom, 'vhcCompany1', row.vhcCompanyName)
      }

      if (row.purposeId == -1) {
        this.$set(this.addFrom, 'purpose', row.purposeName)
      } else {
        this.$set(this.addFrom, 'purpose', { id: row.purposeId, name: row.purposeName })
      }
      this.$set(this.addFrom, 'standards', { id: row.standardsId, name: row.standardsName })
      this.vhcL = { id: row.vhcLongId, name: row.vhcLongName }
      if (row.vhcPhoto1 != '') {
        this.$set(this.listImg, 0, { status: 'ready', url: row.vhcPhoto1Url })
        this.isAddImg = true
      } else {
        this.listImg = []
        this.isAddImg = false
      }

      if (row.vhcPhoto2 != '') {
        this.$set(this.listImg1, 0, { status: 'ready', url: row.vhcPhoto2Url })
        this.isAddImg1 = true
      } else {
        this.listImg1 = []
        this.isAddImg1 = false
      }
    },
    // 修改
    modifyVeicle (row) {
      this.fuzhi(row)
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.typeId = row.vhcTypeId
      this.listByTypeId()
    },
    saveFn (formName) {
      let that = this
      function img2Fn () {
        console.log(that.addFrom.vhcPhoto2)
        if (that.addFrom.vhcPhoto2 == '' && that.listImg1.length > 0) {
          compressImage(that.listImg1[0].url, that.listImg1[0].raw, {
            width: 1000
          }).then(result => {
            that.imgfile.set('vhcPhoto2File', result)// result即为压缩后的结果
            that.save1()
          })
        } else {
          that.save1()
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addFrom.vhcNature = this.addFrom.vhcClassify1[1]
          this.addFrom.vhcClassify = this.addFrom.vhcClassify1[0]
          this.addFrom.vhcTypeName = this.addFrom.vhcType.name
          this.addFrom.vhcTypeId = this.addFrom.vhcType.id
          if (this.addFrom.purpose) {
            if (typeof (this.addFrom.purpose) == 'string') {
              this.addFrom.purposeName = this.addFrom.purpose
              this.addFrom.purposeId = -1
            } else {
              if (this.addFrom.purpose.id == '') {
                this.addFrom.purposeName = null
              } else {
                this.addFrom.purposeName = this.addFrom.purpose.name
              }
              this.addFrom.purposeId = this.addFrom.purpose.id
            }
          }
          if (this.addFrom.standards) {
            if (this.addFrom.standards.id == '') {
              this.addFrom.standardsName = null
            } else {
              this.addFrom.standardsName = this.addFrom.standards.name
            }
            this.addFrom.standardsId = this.addFrom.standards.id
          }
          if (this.addFrom.vhcNature == 1) {
            if (this.addFrom.vhcCompany) {
              if (typeof (this.addFrom.vhcCompany) == 'string') {
                this.addFrom.vhcCompanyName = this.addFrom.vhcCompany
                this.addFrom.vhcCompanyCode = -1
              } else {
                this.addFrom.vhcCompanyName = this.addFrom.vhcCompany.tenantName
                this.addFrom.vhcCompanyCode = this.addFrom.vhcCompany.tenantCode
              }
            }
          } else {
            this.addFrom.vhcCompanyName = this.addFrom.vhcCompany1
            this.addFrom.vhcCompanyCode = -1
          }
          if (this.vhcL.id == '') {
            this.addFrom.vhcLongName = null
          } else {
            this.addFrom.vhcLongName = this.vhcL.name
          }
          this.addFrom.vhcLongId = this.vhcL.id

          this.imgfile.set('params', JSON.stringify(this.addFrom))
          let that = this
          console.log(this.addFrom)
          if (this.listImg.length > 0 && this.addFrom.vhcPhoto1 == '') {
            compressImage(this.listImg[0].url, this.listImg[0].raw, {
              width: 1000
            }).then(result => {
              console.log(result)
              that.imgfile.set('vhcPhoto1File', result)// result即为压缩后的结果
              img2Fn()
            })
          } else {
            img2Fn()
          }
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      if (this.isAdd) {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIadd(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '添加成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIupdate(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 删除
    delVeicle () {
      const selectData = this.$refs.table.selection
      // 司机管理和车辆管理的删除功能改成仅支持单条删除（韦苗苗）
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据')
      } else if (selectData.length > 1) {
        this.$alert('只能选择一条数据进行操作')
      } else {
        var that = this
        this.ids = []
        this.tenantIds = []
        selectData.some(item => {
          that.ids.push(item.id)
          that.tenantIds.push(item.tenantId)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cVIdelete({ ids: this.ids, isZhb: this.searchFrom.isZhb, tenantIds: this.tenantIds }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: false,
              duration: 3000,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },

    closeDialog () {
      this.addFrom = {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        weight: 40,
        vhcType: { id: 23 }
      }
      this.vhcType = {}
      this.vhcL = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.imgfile.set('vhcPhoto1File', '')
      this.imgfile.set('vhcPhoto2File', '')
      this.imgfile.set('params', '')
      this.listImg = []
      this.listImg1 = []
      this.isAddImg = false
      this.isAddImg1 = false
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        registerDates: null,
        isZhb: this.searchFrom.isZhb
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      let str = ''
      if (cellValue) {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // ----------------厂内用车项目新加  机型/吨位下拉框
    // 车辆类型值改变
    vhcTypeChange (val) {
      console.log(val.id, 'val')
      this.typeId = val.id
      this.addFrom.vhcT2linkId = ''
      this.listByTypeId()
    },
    listByTypeId () {
      listByTypeId(this.typeId).then(res => {
        this.carTypeOptions = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    carAreaChange () {
      this.$forceUpdate() // 强制刷新
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
.jiaoyan /deep/.el-date-editor {
    width: 150px!important;
}
/deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
}
.box{
  display: flex;
  justify-content: space-around;
  .imgBox{
    display: flex;
    flex-direction: column;
    width: 386px;
    /deep/.el-upload--picture-card{
          width: 386px;
    height: 240px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 386px;
    height: 240px;
  }
}
.loogImgBox{
  display: flex;
  justify-content: space-around;
  .box1{
    width: 48%;
  }
  img{
    width: 100%;
  }
}

  /deep/.inpBox .bigInp .el-input__inner{
width: 250px;
}
</style>
